// Iconos SVG inline: nada de librerias de iconos, pesan de mas.

const base = (d: string, clase: string) =>
  `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
        stroke-linecap="round" stroke-linejoin="round" class="${clase}">${d}</svg>`;

/**
 * El logo de la app. Es el mismo dibujo que el icono del celular, en 64px:
 * el de 192 pesa 88 KB para mostrarse a 28 puntos.
 */
export const logoApp = (clase = "h-7 w-7") =>
  `<img src="/icono-64.png" alt="" width="64" height="64" class="${clase} shrink-0 rounded-lg" />`;

export const iconoSalir = base(
  `<path d="M15 17l5-5-5-5"/><path d="M20 12H9"/>
   <path d="M13 4H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h7"/>`,
  "h-5 w-5",
);

export const iconoTilde = base(`<path d="M4.5 12.5l5 5 10-11"/>`, "h-5 w-5");

export const iconoMas = base(`<path d="M12 5v14"/><path d="M5 12h14"/>`, "h-5 w-5");

export const iconoVolver = base(
  `<path d="M15 5l-7 7 7 7"/>`,
  "h-5 w-5",
);

export const iconoChevron = base(`<path d="M6 9l6 6 6-6"/>`, "h-4 w-4");

export const iconoFlechaDer = base(`<path d="M9 5l7 7-7 7"/>`, "h-4 w-4");

export const iconoCerrar = base(`<path d="M6 6l12 12"/><path d="M18 6L6 18"/>`, "h-5 w-5");

/** El signo de pregunta del centro de ayuda. */
export const iconoAyuda = base(
  `<circle cx="12" cy="12" r="9"/>
   <path d="M9.5 9.2a2.6 2.6 0 0 1 5 .9c0 1.7-2.5 2.1-2.5 3.9"/>
   <path d="M12 17.3h.01"/>`,
  "h-5 w-5",
);

/** Micrófono: la captura por dictado. */
export const iconoMicrofono = base(
  `<rect x="9" y="2.5" width="6" height="11" rx="3"/>
   <path d="M5.5 11a6.5 6.5 0 0 0 13 0"/>
   <path d="M12 17.5V21"/>`,
  "h-6 w-6",
);

export const iconoMenu = base(
  `<path d="M4 7h16"/><path d="M4 12h16"/><path d="M4 17h16"/>`,
  "h-6 w-6",
);

/** Campana: los recordatorios que vuelven. */
export const iconoCampana = base(
  `<path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9"/>
   <path d="M10.3 21a2 2 0 0 0 3.4 0"/>`,
  "h-5 w-5",
);

/** Candado: la tarea esta esperando a otra. */
export const iconoBloqueada = base(
  `<rect x="4.5" y="10.5" width="15" height="10" rx="2"/>
   <path d="M8 10.5V7.5a4 4 0 0 1 8 0v3"/>`,
  "h-3.5 w-3.5",
);

/** El tacho de basura: tirar un proyecto y vaciar. */
export const iconoTacho = base(
  `<path d="M4 7h16"/><path d="M10 11v6"/><path d="M14 11v6"/>
   <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2l1-12"/>
   <path d="M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>`,
  "h-5 w-5",
);
